var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.visible,"top":"5%","title":"图片预览","width":"1200px","close-on-click-modal":false},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('el-row',{attrs:{"type":"flex","justify":"center"}},[_c('img',{staticStyle:{"max-width":"100%","max-height":"75vh"},attrs:{"src":_vm.url,"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }